import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "MapPin.svg",
  "use": "MapPin.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"MapPin.svg\"><path d=\"M45.023,21.0039A13.0084,13.0084,0,0,1,34.55,33.7629l-.2664,7.1977q-.2614,7.0588-1.1375,14.0749a1.1328,1.1328,0,0,1-2.2483,0q-.8754-7.0093-1.1374-14.0749l-.2664-7.1977A13.0074,13.0074,0,1,1,45.023,21.0039Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol